module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"phone":"Phone number","error":"Incorrect phone number"}}')
  delete Component.options._Ctor
}
